// a no-op migration for the initial snapshot, use as a template for new migrations
export function snapshotMigration0000(snapshot) {
    return snapshot;
}
//# sourceMappingURL=snapshotMigration0000.js.map